import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrntButton, CrntIcon } from '@crnt/web-angular';

@Component({
  selector: 'app-mandatory-email-info-card',
  standalone: true,
  imports: [CommonModule, CrntButton, CrntIcon],
  templateUrl: './mandatory-email-info-card.component.html',
  styleUrl: './mandatory-email-info-card.component.scss',
})
export class MandatoryEmailInfoCardComponent {
  title = input.required<string>();
  description = input.required<string>();
  buttonText = input.required<string>();
  buttonLink = input.required<string>();

  onButtonClick(): void {
    const link = this.buttonLink();
    if (link) {
      window.location.href = link;
    }
  }
}
